import React, {memo, useEffect, useMemo, useState} from 'react';

import {getRouteList} from '../../routes';
import {AppComponent} from './component';
import {
    closePopupScreenAction,
    passwordCheckingTimeoutAction,
    toggleScenarioFooterPopupScreenAction,
    toggleScenarioPopupScreenAction,
} from '../../store/ui/actions';
import {useWindowSize} from '../../hooks/window-size';
import {useHistory, useLocation} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {useMessage} from '../../hooks/message';
import {useSortBySelector} from '../../hooks/sort-by-selector';
import {setIntercomInfoAction, setIntercomStatusAction, setPasswordAction, setScreenSaverStatusAction, setTouchMessageAction} from '../../store/control/actions';
import {useLocalization} from "../../hooks/localization";

const routes = getRouteList();
let timer
export const App = memo(function App() {
    const dispatch = useDispatch();
    const {t} = useLocalization();
    const {info, success, failure} = useMessage();
    const busy = useSelector(state => state.ui.busy);
    const scenarioScreenVisible = useSelector(state => state.ui.scenarioScreen.visible);
    const passwordTimeoutSycle = useSelector(state => state.ui.passwordTimeoutSycle)
    const scenarioTriggerScreenVisible = useSelector(state => state.ui.triggerScreen.visible);
    const scenarioTriggerControlVisible = useSelector(state => Boolean(state.ui.triggerControlScreen.selectedTrigger));
    const scenarioSTPUIControlVisible = useSelector(state => Boolean(state.ui.triggerControlScreen.selectedUIEntity));
    const scenarioTriggerControlUpdateScreenVisible = scenarioTriggerControlVisible || scenarioSTPUIControlVisible;
    const mediaScreenVisible = useSelector(state => state.ui.mediaScreen.visible);
    const stpUIMediaScreenVisible = useSelector(state => state.ui.stpUIMediaScreen.visible);
    const popupScreenVisible = useSelector(state => state.ui.popupState.visible);
    const popupAlarmPasswordScreenVisible = useSelector(state => state.ui.popupAlarmPasswordState.visible)
    const defaultAlarmState = useSelector(state => state.control.alarmState.default);
    const applicationLoaded = useSelector(state => state.ui.applicationLoaded);
    const alarmSettingUp = useSelector(state => state.ui.alarmSettingUp);
    const mediaStatus = useSelector(state => state.control.mediaStatus);
    const rawLeftMenuList = useSortBySelector(state => state.control.menuList, m => m.order);
    const intercomList = useSelector(state => state.control.intercomList);
    const touchMessageSelector = useSelector(state => state.control.touchMessageStatus);
    const leftMenuList = useMemo(() => rawLeftMenuList.map(leftMenu => {
        if (leftMenu.is_special && leftMenu.id === 'intercom') {
            return {
                ...leftMenu,
                onClick: (e) => {
                    if (intercomList && intercomList.length === 1) {
                        e.preventDefault();
                        dispatch(setIntercomInfoAction(intercomList[0]));
                        dispatch(setIntercomStatusAction('special', true));
                    }
                },
            };
        }
        return leftMenu;
    }), [dispatch, intercomList, rawLeftMenuList]);

    const role = useSelector(state => state.ui.role);
    const [width, height] = useWindowSize();
    const history = useHistory();
    const location = useLocation();

    const isPc = useMemo(() => {
        return !((width === 1024 && height === 600) || (height === 1024 && width === 600));
    }, [width, height]);
    const screenSaverStatus = useSelector(state => state.control.screenSaverStatus);
    const passStatus = useSelector(state => state.control.passwordStatus);


    const alarmRinging = defaultAlarmState.ringing || defaultAlarmState.will_ring || defaultAlarmState.level === 3;
    const locked = (alarmRinging || role == null || alarmSettingUp) && !location.pathname.includes('/settings');
    const lockedReason = locked !== true ? '' :
        (defaultAlarmState.level === 3 ? t('outdoor_alarm_set') :
                (alarmRinging ? t('alarm_run') :
                        (role == null ? t('') :
                                (alarmSettingUp ? t('setting_alarm') :
                                    t('unknown_reason'))
                        )
                )
        );
    useEffect(() => {
        if (passStatus === false && alarmSettingUp !== true && !location.pathname.includes('/alarm')) {
            history.push('/lock');
        }
    }, [history, passStatus, alarmSettingUp, location.pathname]);

    useEffect(() => {
        if (alarmRinging) {
            dispatch(toggleScenarioPopupScreenAction(null));
            dispatch(toggleScenarioFooterPopupScreenAction(null))
            if (!location.pathname.includes('/settings') && !location.pathname.includes('/alarm')) {
                history.push('/alarm');
            }
        }
    }, [dispatch, history, location.pathname, alarmRinging, role]);

    //todo refactor
    useEffect(() => {
        if (screenSaverStatus === 'digital-clock') {
            dispatch(toggleScenarioPopupScreenAction(null));
            dispatch(toggleScenarioFooterPopupScreenAction(null))
            if (!location.pathname.includes('/settings') && !location.pathname.includes('/alarm')) {
                history.push('/digital-clock');
            }else{
                 dispatch(setScreenSaverStatusAction(""))
            }
        } else if (screenSaverStatus === 'slider') {
            dispatch(toggleScenarioPopupScreenAction(null));
            dispatch(toggleScenarioFooterPopupScreenAction(null))
            if (!location.pathname.includes('/settings') && !location.pathname.includes('/alarm')) {
                history.push('/slider');
            }else{
                 dispatch(setScreenSaverStatusAction(""))
            }
        } else if (screenSaverStatus === 'analog-clock') {
            dispatch(toggleScenarioPopupScreenAction(null));
            dispatch(toggleScenarioFooterPopupScreenAction(null))
            if (!location.pathname.includes('/settings') && !location.pathname.includes('/alarm')) {
                history.push('/analog-clock');
            }else{
                 dispatch(setScreenSaverStatusAction(""))
            }
        }
    }, [dispatch, history, location.pathname, screenSaverStatus, role]);

    useEffect(() => {
        if(passwordTimeoutSycle) {
            timer = setTimeout(() => {
                dispatch(passwordCheckingTimeoutAction(false))
            }, 30000)
        }else{
            clearTimeout(timer)
        }
    })

    useEffect(() => {
        if (mediaStatus === 'closed') {
            dispatch(closePopupScreenAction());
        } else if (mediaStatus === 'recording') {
            info(t('pls_press_the_corresponding_button_of_remote'), false);
        } else if (mediaStatus === 'succeeded') {
            success(t('registration_successful'));
        } else if (mediaStatus === 'failed') {
            failure(t('registration_failed__try_again'));
        }
    }, [t, dispatch, failure, info, mediaStatus, success]);

   useEffect(() => {
       dispatch(setTouchMessageAction(null))
       if (
           touchMessageSelector != null &&
           (location.pathname === "/slider" ||
               location.pathname === "/analog-clock" ||
               location.pathname === "/digital-clock")
       ) {
           dispatch(setScreenSaverStatusAction(""))
           dispatch(setTouchMessageAction(null))
           history.push("/")
       }
   }, [location.pathname, dispatch, history, touchMessageSelector])

   const alarmStatus = useSelector(state => state.control.alarmTimer)
   useEffect(() => {
       if (
           alarmStatus?.timer_is_running &&
           !location.pathname.includes("/settings") &&
           !location.pathname.includes("/alarm")
       ) {
           history.push("/alarm")
       }
   }, [alarmStatus, location.pathname, history])

    return (
        <AppComponent
            leftMenuList={leftMenuList}
            busy={busy}
            locked={locked}
            lockedReason={lockedReason}
            routes={routes}
            isPc={isPc}
            scenarioCreateScreenVisible={scenarioScreenVisible}
            scenarioTriggerCreateScreenVisible={scenarioTriggerScreenVisible}
            scenarioTriggerControlUpdateScreenVisible={scenarioTriggerControlUpdateScreenVisible}
            mediaScreenVisible={mediaScreenVisible}
            popupScreenVisible={popupScreenVisible}
            popupAlarmPasswordScreenVisible={popupAlarmPasswordScreenVisible}
            applicationLoaded={applicationLoaded}
            stpUIMediaScreenVisible={stpUIMediaScreenVisible}
        />
    )
});
